//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { IMaskComponent } from 'vue-imask';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
import { version } from '../../package.json';
import ViuInput from '../viu-input/viu-input.vue';
// import ViuCheckbox from '../viu-checkbox/viu-checkbox.vue';
import ViuButton from '../viu-button/viu-button.vue';
import ViuFloatingInteractive from '../viu-floating-interactive/viu-floating-interactive.vue';

dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

function formatDate(value) {
  const pattern = new RegExp(/^((1[6-9])|([2-9]\d))\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
  if (pattern.test(value)) {
    return dayjs(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }
  return value;
}

export default {
  name: 'ViuCalendar',
  components: {
    ViuInput,
    // ViuCheckbox,
    ViuButton,
    ViuFloatingInteractive,
    IMaskComponent
  },
  props: {
    /**
     * Valor proporcionado para inicializar el calendario. Debe tener estructura yyyy-mm-dd.
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Propiedad para definir el tipo de calendario a renderizar.
     * @values day, month, year, range
     */
    type: {
      type: String,
      default: 'day',
      validator(value) {
        if (['day', 'month', 'year', 'range'].includes(value)) {
          return true;
        }

        throw new Error(
          `El type proporcionado no corresponde con las opciones aceptadas ('day', 'month', 'year', 'range')`
        );
      }
    },
    /**
     * Dehabilita el uso del calendario.
     */
    disabled: Boolean,
    /**
     * Deshabilita la modificacion del calendario.
     */
    readOnly: Boolean,
    /**
     * se establecen estilos
     * en funcion de su valor
     * y se muestra un mensaje de error
     * si es invalido
     */
    invalid: {
      type: [Boolean, String],
      default: false
    },
    /**
     * Define si sera requerido al hacer la comprobación.
     */
    required: Boolean,
    /**
     * Fecha mínima seleccionable (yyyy-mm-dd)
     */
    minDate: {
      type: String,
      default: '',
      validator(value) {
        if (value === '') {
          return true;
        }
        const pattern = new RegExp(
          /^((1[6-9])|([2-9]\d))\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
        );
        if (pattern.test(value)) {
          return true;
        }
        throw new Error(`El formato para minDate no es el correcto (yyyy-mm-dd)`);
      }
    },
    /**
     * Fecha mmáxima seleccionable (yyyy-mm-dd)
     */
    maxDate: {
      type: String,
      default: '',
      validator(value) {
        if (value === '') {
          return true;
        }
        const pattern = new RegExp(
          /^((1[6-9])|([2-9]\d))\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
        );
        if (pattern.test(value)) {
          return true;
        }
        throw new Error(`El formato para maxDate no es el correcto (yyyy-mm-dd)`);
      }
    },
    /**
     * Establecer clases en elemento donde lanza los eventos para testing QA
     */
    dusk: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    dateCalComponent: '',
    format(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      const year = date.getFullYear();

      if (day < 10) day = `0${day}`;
      if (month < 10) month = `0${month}`;

      return [day, month, year].join('/');
    },
    // define str -> date convertion
    parse(str) {
      const yearMonthDay = str.split('/');
      return new Date(yearMonthDay[2], yearMonthDay[1] - 1, yearMonthDay[0]);
    },
    invalidStorage: false,
    active: false,
    focusStyle: false,
    focus1: false,
    focus2: false,
    current: {
      today: {
        name: 'Hoy',
        value: {
          start: dayjs().format('YYYY-MM-DD'),
          end: dayjs().format('YYYY-MM-DD')
        }
      },
      yesterday: {
        name: 'Ayer',
        value: {
          start: dayjs()
            .subtract(1, 'day')
            .format('YYYY-MM-DD'),
          end: dayjs()
            .subtract(1, 'day')
            .format('YYYY-MM-DD')
        }
      },
      last7Days: {
        name: 'Últimos 7 días',
        value: {
          start: dayjs()
            .subtract(7, 'day')
            .format('YYYY-MM-DD'),
          end: dayjs().format('YYYY-MM-DD')
        }
      },
      last30Days: {
        name: 'Últimos 30 días',
        value: {
          start: dayjs()
            .subtract(30, 'day')
            .format('YYYY-MM-DD'),
          end: dayjs().format('YYYY-MM-DD')
        }
      },
      last3Months: {
        name: 'Últimos 3 meses',
        value: {
          start: dayjs()
            .subtract(3, 'month')
            .format('YYYY-MM-DD'),
          end: dayjs().format('YYYY-MM-DD')
        }
      },
      last6Months: {
        name: 'Últimos 6 meses',
        value: {
          start: dayjs()
            .subtract(6, 'month')
            .format('YYYY-MM-DD'),
          end: dayjs().format('YYYY-MM-DD')
        }
      },
      lastYear: {
        name: 'Último año',
        value: {
          start: dayjs()
            .subtract(1, 'year')
            .format('YYYY-MM-DD'),
          end: dayjs().format('YYYY-MM-DD')
        }
      }
    },
    selectedDate1: '',
    selectedDate2: '',
    selectedFormattedDate1: '',
    selectedFormattedDate2: '',
    comparatedDate1: '',
    comparatedDate2: '',
    activeComparison: false,
    years: [],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    monthsCompleted: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ],
    dayNames: ['LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB', 'DOM'],
    days: [],
    temporal: {
      yearSelected: 0,
      monthSelected: 0,
      year1: 0,
      month1: 0,
      year2: 0,
      month2: 0
    },
    minsMaxs: {
      minYear: 1970,
      maxYear: 2099,
      minDateConstruct: new Date(1970, 0, 1),
      maxDateConstruct: new Date(5000, 11, 31)
    },
    partSelected: '',
    rangeFinished: false,
    selectedFinal: '',
    totalWidth: 0,
    realChange: false,
    closing: false,
    version
  }),
  computed: {
    monthActual() {
      return this.monthsCompleted[this.temporal.monthSelected - 1];
    },
    isInvalid() {
      return this.invalid !== false || this.invalidStorage;
    },
    showInvalidReason() {
      return this.isInvalid && typeof this.invalid === 'string';
    },
    invalidReason() {
      if (typeof this.invalid === 'string') {
        return this.invalid;
      }
      return '';
    }
  },
  watch: {
    minDate: {
      immediate: true,
      handler(valor) {
        if (valor !== '') {
          const fecha = valor.split('-');
          this.minsMaxs.minDateConstruct = new Date(fecha[0], fecha[1] - 1, fecha[2]);
          switch (this.type) {
            case 'day':
              if (this.value !== '' && valor > this.value) {
                this.clearCalendar();
              }
              break;
            case 'month':
              if (this.value !== '' && dayjs(valor, 'YYYY-MM-DD').format('YYYY-MM') > this.value) {
                this.clearCalendar();
              }
              break;
            case 'year':
              if (this.value !== '' && dayjs(valor, 'YYYY-MM-DD').format('YYYY') > this.value) {
                this.clearCalendar();
              }
              break;
            case 'range':
              if (
                this.value !== '' &&
                (valor > this.value.split('|')[0] || valor > this.value.split('|')[1])
              ) {
                this.clearCalendar();
              }
              break;
            default:
              break;
          }
        }
        if (valor === '' && this.minsMaxs.minYear !== 1970) {
          this.minsMaxs.minDateConstruct = new Date(1970, 0, 1);
          switch (this.type) {
            case 'day':
              if (this.value !== '' && this.value < '1970-01-01') {
                this.clearCalendar();
              }
              break;
            case 'month':
              if (this.value !== '' && this.value < '1970-01') {
                this.clearCalendar();
              }
              break;
            case 'year':
              if (this.value !== '' && this.value < '1970') {
                this.clearCalendar();
              }
              break;
            case 'range':
              if (
                this.value !== '' &&
                (this.value.split('|')[0] < '1970-01-01' || this.value.split('|')[1] < '1970-01-01')
              ) {
                this.clearCalendar();
              }
              break;
            default:
              break;
          }
        }
        this.initDates();
      }
    },
    maxDate: {
      immediate: true,
      handler(valor) {
        if (valor !== '') {
          const fecha = valor.split('-');
          this.minsMaxs.maxDateConstruct = new Date(fecha[0], fecha[1] - 1, fecha[2]);
          switch (this.type) {
            case 'day':
              if (this.value !== '' && valor < this.value) {
                this.clearCalendar();
              }
              break;
            case 'month':
              if (this.value !== '' && dayjs(valor, 'YYYY-MM-DD').format('YYYY-MM') < this.value) {
                this.clearCalendar();
              }
              break;
            case 'year':
              if (this.value !== '' && dayjs(valor, 'YYYY-MM-DD').format('YYYY') < this.value) {
                this.clearCalendar();
              }
              break;
            case 'range':
              if (
                this.value !== '' &&
                (valor < this.value.split('|')[0] || valor < this.value.split('|')[1])
              ) {
                this.clearCalendar();
              }
              break;
            default:
              break;
          }
        }
        if (valor === '' && this.minsMaxs.maxYear !== 2099) {
          this.minsMaxs.maxDateConstruct = new Date(5000, 11, 31);
          switch (this.type) {
            case 'day':
              if (this.value !== '' && this.value > '2099-12-31') {
                this.clearCalendar();
              }
              break;
            case 'month':
              if (this.value !== '' && this.value > '2099-12') {
                this.clearCalendar();
              }
              break;
            case 'year':
              if (this.value !== '' && this.value > '2099') {
                this.clearCalendar();
              }
              break;
            case 'range':
              if (
                this.value !== '' &&
                (this.value.split('|')[0] > '2099-12-31' || this.value.split('|')[1] > '2099-12-31')
              ) {
                this.clearCalendar();
              }
              break;
            default:
              break;
          }
        }
      }
    },
    value: {
      immediate: true,
      handler(valor) {
        if (valor !== '' && !this.realChange && this.type === 'day') {
          this.selectDay({ date: valor, otherMonth: false });
          this.applyChangesButton();
        }
      }
    }
  },
  created() {
    this.setWidthTippy();
    this.initDates();
    this.setPossibleYears();
    window.addEventListener('click', this.handlerFocus);
    window.addEventListener('resize', this.handlerResize);
    this.$nextTick(() => {
      this.$el.getElementsByClassName('viu-floating-interactive')[0].firstChild.tabIndex = -1;
    });
  },
  destroyed() {
    window.removeEventListener('click', this.handlerFocus);
    window.removeEventListener('resize', this.handlerResize);
  },
  methods: {
    handlerFocus(e) {
      if (
        this.$el.querySelector('.selected-date') &&
        !this.$el.querySelector('.selected-date').contains(e.target) &&
        this.$el.querySelector('.viu-calendar-inside') &&
        !this.$el.querySelector('.viu-calendar-inside').contains(e.target)
      ) {
        this.closeCalendar();
      }
    },
    handlerResize() {
      if (this.active) {
        this.closeCalendar();
      }
    },
    focused() {
      if (!this.disabled && !this.readOnly) {
        let finished = false;
        if (this.active && !finished) {
          this.closeCalendar();
          this.initDates();
          finished = true;
        }
        if (!this.active && !finished) {
          if (this.value !== '') {
            this.partSelected = '';
          }
          this.active = true;
          this.$nextTick(() => {
            const element = document
              .querySelector('.viu-calendar-inside')
              .querySelector('.year-block')
              .querySelector('.content')
              .querySelector('.today');

            if (element) {
              document
                .querySelector('.viu-calendar-inside')
                .querySelector('.year-block')
                .querySelector('.content')
                .querySelector('.today')
                .scrollIntoView({ block: 'nearest' });
            }
          });
        }
      }
    },
    closeCalendar() {
      this.closing = true;
      setTimeout(() => {
        this.closing = false;
        this.active = false;
        this.initDates();
      }, 180);
    },
    clearCalendar(reset = true) {
      if (this.readOnly || this.disabled) return;

      this.temporal = {
        yearSelected: 0,
        monthSelected: 0,
        year1: 0,
        month1: 0,
        year2: 0,
        month2: 0
      };
      this.selectedFinal = '';
      this.selectedDate1 = '';
      this.selectedDate2 = '';
      this.selectedFormattedDate1 = '';
      this.selectedFormattedDate2 = '';
      this.comparatedDate1 = '';
      this.comparatedDate2 = '';
      if (reset) {
        this.dateCalComponent = '';
      }
      this.emitValue('');
      this.$nextTick(() => {
        this.initDates();
        this.setPossibleYears();
      });
    },
    onAccept(value) {
      if (!dayjs(value, 'DD/MM/YYYY').isValid()) {
        this.clearCalendar(false);
      }
    },
    onCompleteDate(value) {
      this.selectDay({ date: dayjs(value, 'DD/MM/YYYY').format('YYYY-MM-DD'), otherMonth: false });
      this.applyChangesButton();
    },
    keyFocus(from) {
      this.focusStyle = true;
      if (from === 1 && this.value === '' && this.type === 'day') {
        this.applyChangesButton();
      }
      if (from === 1 && this.value === '' && this.type === 'month') {
        this.applyChangesButton();
      }
      if (from === 1 && this.value === '' && this.type === 'year') {
        this.selectYear(dayjs().format('YYYY'));
      }
      if (from === 1 && this.type === 'range') {
        this.focus1 = true;
        if (this.value === '') {
          this.applyChangesButton();
        }
      }

      if (from === 2 && this.type === 'range') {
        this.focus2 = true;
        if (this.value === '') {
          this.applyChangesButton();
        }
      }
    },
    keyPress(from, ev) {
      if (from === 1 && this.type === 'day') {
        if (ev.keyCode === 38) {
          this.emitValue(
            dayjs(this.value, 'YYYY-MM-DD')
              .add(1, 'day')
              .format('YYYY-MM-DD')
          );
        }
        if (ev.keyCode === 40) {
          this.emitValue(
            dayjs(this.value, 'YYYY-MM-DD')
              .subtract(1, 'day')
              .format('YYYY-MM-DD')
          );
        }
      }
      if (from === 1 && this.type === 'month') {
        if (ev.keyCode === 38) {
          this.emitValue(
            dayjs(this.value, 'YYYY-MM')
              .add(1, 'month')
              .format('YYYY-MM')
          );
        }
        if (ev.keyCode === 40) {
          this.emitValue(
            dayjs(this.value, 'YYYY-MM')
              .subtract(1, 'month')
              .format('YYYY-MM')
          );
        }
      }
      if (from === 1 && this.type === 'year') {
        if (ev.keyCode === 38) {
          this.emitValue(
            dayjs(this.value, 'YYYY')
              .add(1, 'year')
              .format('YYYY')
          );
        }
        if (ev.keyCode === 40) {
          this.emitValue(
            dayjs(this.value, 'YYYY')
              .subtract(1, 'year')
              .format('YYYY')
          );
        }
      }
      if (from === 1 && this.type === 'range') {
        const fecha1 = this.value.split('|')[0];
        const fecha2 = this.value.split('|')[1];
        if (
          ev.keyCode === 38 &&
          dayjs(fecha1, 'YYYY-MM-DD')
            .add(1, 'day')
            .format('YYYY-MM-DD') < fecha2
        ) {
          this.selectedFinal = `${dayjs(fecha1, 'YYYY-MM-DD')
            .add(1, 'day')
            .format('DD/MM/YYYY')} - ${dayjs(fecha2, 'YYYY-MM-DD').format('DD/MM/YYYY')}`;
          this.emitValue(
            `${dayjs(fecha1, 'YYYY-MM-DD')
              .add(1, 'day')
              .format('YYYY-MM-DD')}|${fecha2}`
          );
        }
        if (ev.keyCode === 40) {
          this.selectedFinal = `${dayjs(fecha1, 'YYYY-MM-DD')
            .subtract(1, 'day')
            .format('DD/MM/YYYY')} - ${dayjs(fecha2, 'YYYY-MM-DD').format('DD/MM/YYYY')}`;
          this.emitValue(
            `${dayjs(fecha1, 'YYYY-MM-DD')
              .subtract(1, 'day')
              .format('YYYY-MM-DD')}|${fecha2}`
          );
        }
      }

      if (from === 2 && this.type === 'range') {
        const fecha1 = this.value.split('|')[0];
        const fecha2 = this.value.split('|')[1];
        if (ev.keyCode === 38) {
          this.selectedFinal = `${dayjs(fecha1, 'YYYY-MM-DD').format('DD/MM/YYYY')} - ${dayjs(
            fecha2,
            'YYYY-MM-DD'
          )
            .add(1, 'day')
            .format('DD/MM/YYYY')}`;
          this.emitValue(
            `${fecha1}|${dayjs(fecha2, 'YYYY-MM-DD')
              .add(1, 'day')
              .format('YYYY-MM-DD')}`
          );
        }
        if (
          ev.keyCode === 40 &&
          fecha1 <
            dayjs(fecha2, 'YYYY-MM-DD')
              .add(1, 'day')
              .format('YYYY-MM-DD')
        ) {
          this.selectedFinal = `${dayjs(fecha1, 'YYYY-MM-DD').format('DD/MM/YYYY')} - ${dayjs(
            fecha2,
            'YYYY-MM-DD'
          )
            .subtract(1, 'day')
            .format('DD/MM/YYYY')}`;
          this.emitValue(
            `${fecha1}|${dayjs(fecha2, 'YYYY-MM-DD')
              .subtract(1, 'day')
              .format('YYYY-MM-DD')}`
          );
        }
      }

      if (
        this.type !== 'range' &&
        from === 1 &&
        (ev.keyCode === 9 || (ev.shiftKey && ev.keyCode == 9))
      ) {
        this.focusStyle = false;
        this.focus1 = false;
        this.focus2 = false;
      }

      if (
        this.type === 'range' &&
        ((from === 2 && !ev.shiftKey && ev.keyCode === 9) ||
          (from === 1 && ev.shiftKey && ev.keyCode === 9))
      ) {
        this.focusStyle = false;
        this.focus1 = false;
        this.focus2 = false;
      }
      if (this.type === 'range' && from === 1 && ev.keyCode === 9) {
        this.focus1 = false;
      }
      // eslint-disable-next-line eqeqeq
      if (this.type === 'range' && from === 2 && ev.shiftKey && ev.keyCode == 9) {
        this.focus2 = false;
      }
      if (![9, 38, 40].includes(ev.keyCode)) {
        ev.preventDefault();
      }
    },
    blurKey() {
      this.focusStyle = false;
      this.focus1 = false;
      this.focus2 = false;
    },
    setWidthTippy() {
      const { type } = this;
      /**
       * SE COMPRUEBA POSIBILIDAD DE APERTURA CON LEFT = 0 (DESPLIEGUE POR LA DERECHA)
       */
      switch (type) {
        case 'day':
          this.totalWidth = 541;
          break;
        case 'month':
          this.totalWidth = 248;
          break;
        case 'year':
          this.totalWidth = 350;
          break;
        case 'range':
          this.totalWidth = 692;
          break;
        default:
          break;
      }
    },
    setFocusInput(part) {
      const { selectedDate1, selectedDate2 } = this;
      let selectedDate = selectedDate1 !== '' ? selectedDate1 : dayjs().format('YYYY-MM-DD');
      this.partSelected = part;
      if (part === 'to' && selectedDate2 !== '') {
        selectedDate = selectedDate2;
      }

      this.temporal.yearSelected = Number(dayjs(selectedDate, 'YYYY-MM-DD').format('YYYY'));
      this.temporal.monthSelected = Number(dayjs(selectedDate, 'YYYY-MM-DD').format('M'));

      if (['day', 'range'].includes(this.type)) {
        this.setDays();
      }
    },
    checkInvalid() {
      const { required, value, dateCalComponent, type } = this;
      let status = false;
      let reason = '';

      this.invalidStorage = false;

      if (required && value.length === 0) {
        status = true;
        reason = 'Este campo es requerido';
        this.invalidStorage = status;
        return { status, reason };
      }

      if (
        type === 'day' &&
        !required &&
        value.length === 0 &&
        dateCalComponent.length > 0 &&
        dateCalComponent !== '__/__/____' &&
        !dayjs(dateCalComponent, 'DD/MM/YYYY').isValid()
      ) {
        status = true;
        reason = 'Fecha inválida';
        this.invalidStorage = status;
        return { status, reason };
      }

      return { status, reason };
    },
    checkValue() {
      const { value, type } = this;
      if (value === '') {
        return true;
      }

      const patternDay = new RegExp(
        /^((1[6-9])|([2-9]\d))\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
      );
      if (type === 'day' && patternDay.test(value)) {
        return true;
      }

      const patternRange = new RegExp(
        /^((1[6-9])|([2-9]\d))\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])[|]((1[6-9])|([2-9]\d))\d\d-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
      );
      if (type === 'range' && patternRange.test(value)) {
        return true;
      }

      const patternMonth = new RegExp(/^((1[6-9])|([2-9]\d))\d\d-(0[1-9]|1[012])$/);
      if (type === 'month' && patternMonth.test(value)) {
        return true;
      }

      const patternYear = new RegExp(/^((1[6-9])|([2-9]\d))\d\d$/);
      if (type === 'year' && patternYear.test(value)) {
        return true;
      }

      throw new Error(
        `El formato no es el correcto. Día: 'yyyy-mm-dd', Mes: 'yyyy-mm', Año: 'yyyy', Rango: 'yyyy-mm-dd|yyyy-mm-dd'`
      );
    },
    initDates() {
      const { value, type, minDate } = this;
      this.checkValue();
      this.partSelected = 'from';

      if (value === '') {
        this.temporal.yearSelected = Number(dayjs().format('YYYY'));
        this.temporal.monthSelected = Number(dayjs().format('M'));
        this.temporal.year1 = Number(dayjs().format('YYYY'));
        this.temporal.month1 = Number(dayjs().format('M'));
      }

      if (
        value === '' &&
        type === 'day' &&
        minDate !== '' &&
        dayjs().format('YYYY') > dayjs(minDate, 'YYYY-MM-DD').format('YYYY')
      ) {
        this.temporal.yearSelected = Number(dayjs(minDate, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.monthSelected = Number(dayjs(minDate, 'YYYY-MM-DD').format('M'));
        this.temporal.year1 = Number(dayjs(minDate, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.month1 = Number(dayjs(minDate, 'YYYY-MM-DD').format('M'));
      }

      if (value !== '' && type === 'day') {
        this.selectedDate1 = value;
        this.selectedDate2 = value;
        this.selectedFormattedDate1 = formatDate(value);
        this.selectedFormattedDate2 = formatDate(value);
        this.comparatedDate1 = value;
        this.comparatedDate2 = value;

        this.temporal.yearSelected = Number(dayjs(value, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.monthSelected = Number(dayjs(value, 'YYYY-MM-DD').format('M'));
        this.temporal.year1 = Number(dayjs(value, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.month1 = Number(dayjs(value, 'YYYY-MM-DD').format('M'));
        this.temporal.year2 = Number(dayjs(value, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.month2 = Number(dayjs(value, 'YYYY-MM-DD').format('M'));
        this.selectedFinal = formatDate(value);
      }

      if (value !== '' && type === 'month') {
        this.selectedDate1 = value;

        this.temporal.yearSelected = Number(dayjs(value, 'YYYY-MM').format('YYYY'));
        this.temporal.monthSelected = Number(dayjs(value, 'YYYY-MM').format('M'));
        this.temporal.year1 = Number(dayjs(value, 'YYYY-MM').format('YYYY'));
        this.temporal.month1 = Number(dayjs(value, 'YYYY-MM').format('M'));
        this.temporal.year2 = Number(dayjs(value, 'YYYY-MM').format('YYYY'));
        this.temporal.month2 = Number(dayjs(value, 'YYYY-MM').format('M'));
        this.selectedFormattedDate1 = `${this.months[this.temporal.month1 - 1]}. ${
          this.temporal.year1
        }`;
        this.selectedFinal = `${this.months[this.temporal.month1 - 1]}. ${this.temporal.year1}`;
      }

      if (value !== '' && type === 'year') {
        this.selectedDate1 = value;

        this.temporal.yearSelected = Number(dayjs(value, 'YYYY').format('YYYY'));
        this.temporal.year1 = Number(dayjs(value, 'YYYY').format('YYYY'));
        this.selectedFormattedDate1 = `${this.temporal.year1}`;
        this.selectedFinal = `${this.temporal.year1}`;
      }

      if (value !== '' && type === 'range') {
        const [date1, date2] = value.split('|');
        this.selectedDate1 = date1;
        this.selectedDate2 = date2;
        this.selectedFormattedDate1 = formatDate(date1);
        this.selectedFormattedDate2 = formatDate(date2);
        this.comparatedDate1 = date1;
        this.comparatedDate2 = date2;

        this.temporal.yearSelected = Number(dayjs(date1, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.monthSelected = Number(dayjs(date1, 'YYYY-MM-DD').format('M'));
        this.temporal.year1 = Number(dayjs(date1, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.month1 = Number(dayjs(date1, 'YYYY-MM-DD').format('M'));
        this.temporal.year2 = Number(dayjs(date2, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.month2 = Number(dayjs(date2, 'YYYY-MM-DD').format('M'));
      }

      if (['day', 'range'].includes(type)) {
        this.setDays();
      }
    },
    toogleComparison() {
      this.activeComparison = !this.activeComparison;
    },
    setPossibleYears() {
      const { minDate, maxDate } = this;

      this.minsMaxs.minYear = 1970;
      this.minsMaxs.maxYear = 2099;

      if (minDate !== '') {
        this.minsMaxs.minYear = Number(dayjs(minDate, 'YYYY-MM-DD').format('YYYY'));
      }
      if (maxDate !== '') {
        this.minsMaxs.maxYear = Number(dayjs(maxDate, 'YYYY-MM-DD').format('YYYY'));
      }
      if (
        maxDate === '' &&
        this.type !== 'range' &&
        this.value !== '' &&
        dayjs(this.value, ['YYYY', 'YYYY-MM-DD', 'YYYY-MM'], 'es', true)
          .add(1, 'year')
          .format('YYYY') >= this.minsMaxs.maxYear
      ) {
        this.minsMaxs.maxYear = Number(
          dayjs(this.value, ['YYYY', 'YYYY-MM-DD', 'YYYY-MM'], 'es', true)
            .add(1, 'year')
            .format('YYYY')
        );
      }

      this.years = Array(this.minsMaxs.maxYear - this.minsMaxs.minYear + 1)
        .fill()
        .map((_, index) => this.minsMaxs.minYear + index);
    },
    selectYear(selected) {
      const { type } = this;
      this.temporal.yearSelected = selected;
      if (type === 'range' && this.partSelected === 'from') {
        this.temporal.year1 = selected;
      }
      if (type === 'range' && this.partSelected === 'to') {
        this.temporal.year2 = selected;
      }
      if (type === 'month') {
        this.temporal.year1 = selected;
        this.selectedDate1 = `${this.temporal.year1}-${
          this.temporal.month1 < 10 ? `0${this.temporal.month1}` : this.temporal.month1
        }`;
        this.selectedFormattedDate1 = `${this.months[this.temporal.month1 - 1]}. ${
          this.temporal.year1
        }`;
      }
      if (type === 'year') {
        this.temporal.year1 = selected;
        this.selectedDate1 = this.temporal.year1;
        this.selectedFinal = this.temporal.year1;
        this.selectedFormattedDate1 = this.temporal.year1;
        this.emitValue(`${this.selectedDate1}`);
      }

      if (['day', 'range'].includes(type)) {
        this.setDays();
      }
    },
    selectMonth(selected) {
      const { type, months } = this;
      this.temporal.monthSelected = selected;

      if (type === 'range' && this.partSelected === 'from') {
        this.temporal.month1 = selected;
      }
      if (type === 'range' && this.partSelected === 'to') {
        this.temporal.month2 = selected;
      }
      if (type === 'month') {
        this.temporal.month1 = selected;
        this.selectedDate1 = `${this.temporal.year1}-${dayjs(
          `2020-${this.temporal.month1}-01`,
          'YYYY-M-DD'
        ).format('MM')}`;
        this.selectedFormattedDate1 = `${months[this.temporal.month1 - 1]}. ${this.temporal.year1}`;
      }

      if (['day', 'range'].includes(type)) {
        this.setDays();
      }
    },
    setDays() {
      const { minDate, maxDate } = this;
      let minDay = '1970-01-01';
      let maxDay = '5010-12-31';

      if (minDate !== '') minDay = minDate;
      if (maxDate !== '') maxDay = maxDate;

      const arrAllDays = new Array(
        dayjs(
          `${this.temporal.yearSelected}-${this.temporal.monthSelected}-01`,
          'YYYY-M-01'
        ).daysInMonth()
      ).fill(null);

      const currentMonthDays = arrAllDays.map((x, i) => {
        const objResult = {};
        const tempDate = dayjs(
          `${this.temporal.yearSelected}-${this.temporal.monthSelected}`,
          'YYYY-M'
        )
          .startOf('month')
          .add(i, 'day');
        objResult.numberDay = Number(tempDate.format('D'));
        objResult.date = tempDate.format('YYYY-MM-DD');
        objResult.numberWeek = Number(tempDate.format('W'));
        objResult.weekPosition = Number(tempDate.isoWeekday());
        objResult.otherMonth = false;
        objResult.disableDay = !!(
          String(tempDate.format('YYYY-MM-DD')) < minDay ||
          String(tempDate.format('YYYY-MM-DD')) > maxDay
        );
        return objResult;
      });

      if (currentMonthDays[0].weekPosition !== 1) {
        let tempWeekPosition = currentMonthDays[0].weekPosition;

        do {
          const objResult = {};
          const tempDate = dayjs(currentMonthDays[0].date, 'YYYY-MM-DD').subtract(1, 'day');
          objResult.numberDay = Number(tempDate.format('D'));
          objResult.date = tempDate.format('YYYY-MM-DD');
          objResult.numberWeek = Number(tempDate.format('W'));
          objResult.weekPosition = Number(tempDate.isoWeekday());
          objResult.otherMonth = true;
          objResult.disableDay = !!(
            String(tempDate.format('YYYY-MM-DD')) < minDay ||
            String(tempDate.format('YYYY-MM-DD')) > maxDay
          );
          currentMonthDays.unshift(objResult);
          tempWeekPosition -= 1;
        } while (tempWeekPosition !== 1);
      }

      if (currentMonthDays[currentMonthDays.length - 1].weekPosition !== 7) {
        let tempWeekPosition = currentMonthDays[currentMonthDays.length - 1].weekPosition;

        do {
          const objResult = {};
          const tempDate = dayjs(
            currentMonthDays[currentMonthDays.length - 1].date,
            'YYYY-MM-DD'
          ).add(1, 'day');
          objResult.numberDay = Number(tempDate.format('D'));
          objResult.date = tempDate.format('YYYY-MM-DD');
          objResult.numberWeek = Number(tempDate.format('W'));
          objResult.weekPosition = Number(tempDate.isoWeekday());
          objResult.otherMonth = true;
          objResult.disableDay = !!(
            String(tempDate.format('YYYY-MM-DD')) < minDay ||
            String(tempDate.format('YYYY-MM-DD')) > maxDay
          );
          currentMonthDays.push(objResult);
          tempWeekPosition += 1;
        } while (tempWeekPosition < 7);
      }

      const resultArrayDays = [];
      let tempWeek = currentMonthDays.length / 7;
      do {
        const currentSplice = resultArrayDays.length * 7;
        resultArrayDays.push(currentMonthDays.slice(currentSplice, currentSplice + 7));
        tempWeek -= 1;
      } while (tempWeek > 0);

      this.days = resultArrayDays;
    },
    selectCurrent(index) {
      const { current } = this;

      this.selectedDate1 = current[index].value.start;
      this.selectedDate2 = current[index].value.end;
      this.selectedFormattedDate1 = formatDate(current[index].value.start);
      this.selectedFormattedDate2 = formatDate(current[index].value.end);
      this.temporal.year1 = Number(dayjs(current[index].value.start, 'YYYY-MM-DD').format('YYYY'));
      this.temporal.month1 = Number(dayjs(current[index].value.start, 'YYYY-MM-DD').format('M'));
      this.temporal.year2 = Number(dayjs(current[index].value.end, 'YYYY-MM-DD').format('YYYY'));
      this.temporal.month2 = Number(dayjs(current[index].value.end, 'YYYY-MM-DD').format('M'));
      this.temporal.yearSelected = Number(
        dayjs(current[index].value.end, 'YYYY-MM-DD').format('YYYY')
      );
      this.temporal.monthSelected = Number(
        dayjs(current[index].value.end, 'YYYY-MM-DD').format('M')
      );
      this.rangeFinished = true;
      this.partSelected = '';
      this.setDays();
    },
    selectDay(day) {
      const { type } = this;
      let finish = false;

      if (
        type === 'range' &&
        (this.partSelected === '' || this.partSelected === 'from') &&
        !finish
      ) {
        this.selectedDate1 = day.date;
        this.selectedDate2 = '';
        this.selectedFormattedDate1 = formatDate(this.selectedDate1);
        this.selectedFormattedDate2 = '';

        this.temporal.year1 = Number(dayjs(day.date, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.month1 = Number(dayjs(day.date, 'YYYY-MM-DD').format('M'));
        this.temporal.month2 = 0;
        this.temporal.year2 = 0;
        // this.temporal.monthSelected = Number(dayjs(day.date, 'YYYY-MM-DD').format('M'));
        // this.temporal.yearSelected = Number(dayjs(day.date, 'YYYY-MM-DD').format('YYYY'));

        // if (this.temporal.year2 === 0 && this.temporal.month2 === 0) {
        //   this.temporal.month2 = Number(dayjs(day.date, 'YYYY-MM-DD').format('M'));
        //   this.temporal.year2 = Number(dayjs(day.date, 'YYYY-MM-DD').format('YYYY'));
        // }

        this.rangeFinished = false;
        this.partSelected = 'to';
        this.checkAndSetInvertedDates();
        if (day.otherMonth) {
          // this.setDays();
        }
        finish = true;
      }

      if (type === 'range' && this.partSelected === 'to' && !finish) {
        this.selectedDate2 = day.date;
        this.selectedFormattedDate2 = formatDate(this.selectedDate2);
        this.temporal.month2 = Number(dayjs(day.date, 'YYYY-MM-DD').format('M'));
        this.temporal.year2 = Number(dayjs(day.date, 'YYYY-MM-DD').format('YYYY'));
        // this.temporal.monthSelected = Number(dayjs(day.date, 'YYYY-MM-DD').format('M'));
        // this.temporal.yearSelected = Number(dayjs(day.date, 'YYYY-MM-DD').format('YYYY'));
        this.partSelected = '';
        this.rangeFinished = true;
        this.checkAndSetInvertedDates();
        if (day.otherMonth) {
          // this.setDays();
        }
        finish = true;
      }
      if (type === 'day' && !finish) {
        this.selectedDate1 = day.date;
        this.temporal.year1 = Number(dayjs(day.date, 'YYYY-MM-DD').format('YYYY'));
        this.temporal.month1 = Number(dayjs(day.date, 'YYYY-MM-DD').format('M'));
        this.selectedFormattedDate1 = formatDate(this.selectedDate1);
        finish = true;
      }
    },
    getToday(day) {
      const { minDate, maxDate } = this;
      if (day === dayjs().format('YYYY-MM-DD') && minDate === '' && maxDate === '') {
        return true;
      }

      if (
        day === dayjs().format('YYYY-MM-DD') &&
        minDate !== '' &&
        day >= minDate &&
        maxDate === ''
      ) {
        return true;
      }

      if (
        day === dayjs().format('YYYY-MM-DD') &&
        minDate === '' &&
        maxDate !== '' &&
        day <= maxDate
      ) {
        return true;
      }

      if (
        day === dayjs().format('YYYY-MM-DD') &&
        minDate !== '' &&
        maxDate !== '' &&
        day >= minDate &&
        day <= maxDate
      ) {
        return true;
      }

      return false;
    },
    checkAndSetInvertedDates() {
      if (
        this.selectedDate1 !== '' &&
        this.selectedDate2 !== '' &&
        this.selectedDate1 > this.selectedDate2
      ) {
        const temporal = {};
        temporal.date1 = this.selectedDate2;
        temporal.date2 = this.selectedDate1;
        temporal.year1 = this.temporal.year2;
        temporal.year2 = this.temporal.year1;
        temporal.month1 = this.temporal.month2;
        temporal.month2 = this.temporal.month1;

        this.selectedDate1 = temporal.date1;
        this.selectedDate2 = temporal.date2;
        this.temporal.year1 = temporal.year1;
        this.temporal.year2 = temporal.year2;
        this.temporal.month1 = temporal.month1;
        this.temporal.month2 = temporal.month2;

        this.selectedFormattedDate1 = formatDate(this.selectedDate1);
        this.selectedFormattedDate2 = formatDate(this.selectedDate2);

        this.setDays();
      }
    },
    isDisabledMonth(month) {
      const { minDate, maxDate, temporal } = this;
      if (minDate === '' && maxDate === '') {
        return false;
      }

      if (
        minDate !== '' &&
        Number(dayjs(minDate, 'YYYY-MM-DD').format('M')) > month &&
        Number(dayjs(minDate, 'YYYY-MM-DD').format('YYYY')) >= temporal.yearSelected
      ) {
        return true;
      }

      if (
        maxDate !== '' &&
        Number(dayjs(maxDate, 'YYYY-MM-DD').format('M')) < month &&
        Number(dayjs(maxDate, 'YYYY-MM-DD').format('YYYY')) <= temporal.yearSelected
      ) {
        return true;
      }

      return false;
    },
    isDisabledCurrent(currentChecked) {
      const { minDate, maxDate, current } = this;
      if (minDate === '' && maxDate === '') {
        return false;
      }

      let minDay = '1970-01-01';
      let maxDay = '5010-12-31';

      if (minDate !== '') minDay = minDate;
      if (maxDate !== '') maxDay = maxDate;

      if (
        current[currentChecked].value.start < minDay ||
        current[currentChecked].value.end > maxDay
      ) {
        return true;
      }

      return false;
    },
    isActiveYear(year) {
      if (this.type === 'year' && year === this.temporal.year1) {
        return true;
      }

      if (
        (this.type === 'day' || this.type === 'month') &&
        year === this.temporal.year1 &&
        this.selectedDate1 !== ''
      ) {
        return true;
      }

      if (
        (this.type === 'range' &&
          this.selectedDate1 !== '' &&
          this.selectedDate2 !== '' &&
          year === this.temporal.year2) ||
        (year === this.temporal.year1 &&
          this.selectedDate1 !== '' &&
          this.selectedDate2 !== '' &&
          this.temporal.year2 === 0)
      ) {
        return true;
      }

      if (this.type === 'range' && this.partSelected === 'to') {
        return false;
      }

      return false;
    },
    isSecondaryActiveYear(year) {
      if (this.type !== 'range') {
        return false;
      }

      if (
        year === this.temporal.year1 &&
        (this.partSelected === '' || this.partSelected === 'to') &&
        this.temporal.year1 !== this.temporal.year2
      ) {
        return true;
      }

      return false;
    },
    isActiveMonth(month) {
      if (
        this.type === 'day' &&
        this.selectedDate1 !== '' &&
        month === this.temporal.month1 &&
        this.temporal.yearSelected === this.temporal.year1
      ) {
        return true;
      }

      if (this.type === 'month' && month === this.temporal.month1 && this.selectedDate1 !== '') {
        return true;
      }

      if (
        this.type === 'range' &&
        this.partSelected === '' &&
        ((month === this.temporal.month2 && this.temporal.yearSelected === this.temporal.year2) ||
          (month === this.temporal.month1 &&
            this.temporal.month2 === 0 &&
            this.temporal.yearSelected === this.temporal.year1))
      ) {
        return true;
      }

      if (
        this.type === 'range' &&
        this.partSelected === 'from' &&
        this.selectedDate1 !== '' &&
        this.selectedDate2 !== '' &&
        ((month === this.temporal.month2 && this.temporal.yearSelected === this.temporal.year2) ||
          (month === this.temporal.month1 &&
            this.temporal.month2 === 0 &&
            this.temporal.yearSelected === this.temporal.year1))
      ) {
        return true;
      }

      return false;
    },
    isSecondaryActiveMonth(month) {
      if (this.type !== 'range') {
        return false;
      }

      if (
        month === this.temporal.month1 &&
        (this.partSelected === '' || this.partSelected === 'to') &&
        this.temporal.yearSelected === this.temporal.year1 &&
        (this.temporal.month1 !== this.temporal.month2 ||
          this.temporal.year1 !== this.temporal.year2)
      ) {
        return true;
      }

      return false;
    },
    isSelectedDay(day) {
      const { type, selectedDate1, selectedDate2, partSelected } = this;
      if (
        (day === selectedDate1 &&
          (type === 'day' ||
            (type === 'range' && (partSelected === 'from' || partSelected === '')))) ||
        (day === selectedDate2 && type === 'range')
      ) {
        return true;
      }
      return false;
    },
    isSecondarySelectedDay(day) {
      const { type, selectedDate1, partSelected } = this;
      if (
        day === selectedDate1 &&
        type === 'range' &&
        (partSelected === 'to' || partSelected === '')
      ) {
        return true;
      }
      return false;
    },
    isHoveredFromDay(day) {
      const { type, selectedDate1, selectedDate2, rangeFinished } = this;
      if (
        day === selectedDate1 &&
        type === 'range' &&
        selectedDate1 !== selectedDate2 &&
        rangeFinished
      ) {
        return true;
      }
      return false;
    },
    isHoveredToDay(day) {
      const { type, selectedDate1, selectedDate2, rangeFinished } = this;
      if (
        day === selectedDate2 &&
        type === 'range' &&
        selectedDate1 !== selectedDate2 &&
        rangeFinished
      ) {
        return true;
      }
      return false;
    },
    cancelChangesButton() {
      this.closeCalendar();
    },
    applyChangesButton() {
      const { type, selectedDate1, selectedDate2, minDate, maxDate } = this;
      let returnFinal = '';
      this.realChange = true;

      if (type === 'day' && selectedDate1 !== '') {
        this.selectedFinal = formatDate(selectedDate1);
        this.dateCalComponent = JSON.parse(
          JSON.stringify(dayjs(selectedDate1, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        );
        returnFinal = this.selectedDate1;
      }

      if (
        type === 'day' &&
        selectedDate1 === '' &&
        ((minDate === '' && maxDate === '') ||
          (minDate <= this.current.today.value.start && maxDate >= this.current.today.value.start))
      ) {
        this.selectedFinal = formatDate(this.current.today.value.end);
        this.dateCalComponent = JSON.parse(
          JSON.stringify(dayjs(selectedDate1, 'YYYY-MM-DD').format('DD/MM/YYYY'))
        );
        returnFinal = this.current.today.value.end;
      }

      if (type === 'month' && selectedDate1 !== '') {
        this.selectedFinal = `${this.months[this.temporal.month1 - 1]}. ${this.temporal.year1}`;
        returnFinal = this.selectedDate1;
      }

      if (type === 'month' && selectedDate1 === '' && minDate === '' && maxDate === '') {
        this.selectedDate1 = `${this.temporal.year1}-${dayjs(this.temporal.month1, 'M').format(
          'MM'
        )}`;
        this.selectedFormattedDate1 = `${this.months[this.temporal.month1 - 1]}. ${
          this.temporal.year1
        }`;
        this.selectedFinal = `${this.months[this.temporal.month1 - 1]}. ${this.temporal.year1}`;
        returnFinal = dayjs(this.current.today.value.end, 'YYYY-MM-DD').format('YYYY-MM');
      }

      if (type === 'range' && selectedDate1 !== '' && selectedDate2 !== '') {
        const formatted1 = formatDate(selectedDate1);
        const formatted2 = formatDate(selectedDate2);
        this.selectedFinal = `${formatted1} - ${formatted2}`;
        returnFinal = `${selectedDate1}|${selectedDate2}`;
      }

      if (type === 'range' && selectedDate1 === '' && selectedDate2 !== '') {
        this.selectedDate1 = selectedDate2;
        const formatted1 = formatDate(this.selectedDate1);
        const formatted2 = formatDate(selectedDate2);
        this.selectedFinal = `${formatted1} - ${formatted2}`;
        returnFinal = `${this.selectedDate1}|${selectedDate2}`;
      }

      if (type === 'range' && selectedDate1 !== '' && selectedDate2 === '') {
        this.selectedDate2 = selectedDate1;
        const formatted1 = formatDate(selectedDate1);
        const formatted2 = formatDate(this.selectedDate2);
        this.selectedFinal = `${formatted1} - ${formatted2}`;
        returnFinal = `${selectedDate1}|${this.selectedDate2}`;
      }

      if (
        type === 'range' &&
        selectedDate1 === '' &&
        selectedDate2 === '' &&
        minDate === '' &&
        maxDate === ''
      ) {
        this.selectedDate1 = this.current.today.value.start;
        this.selectedDate2 = this.current.today.value.end;
        const formatted1 = formatDate(this.selectedDate1);
        const formatted2 = formatDate(this.selectedDate2);
        this.selectedFinal = `${formatted1} - ${formatted2}`;
        returnFinal = `${this.selectedDate1}|${this.selectedDate2}`;
      }

      if (returnFinal !== '') {
        this.emitValue(returnFinal);
        this.$nextTick(() => {
          this.realChange = false;
        });
      }
    },
    emitValue(returnFinal) {
      this.rangeFinished = true;
      this.invalidStorage = false;
      this.$emit('input', returnFinal);
      this.closeCalendar();
    }
  }
};
